var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.267 6.587-3.06-3.06a.667.667 0 1 0-.94.946l3.066 3.054a.667.667 0 0 1 0 .946l-3.066 3.054a.667.667 0 0 0 .94.946l3.06-3.06a2 2 0 0 0 0-2.826"
  })));
};
export default SvgChevronRight;